module.exports = __webpack_public_path__ + "img/telegram.06b17ce8.svg";